import { render, staticRenderFns } from "./UnassignedList.vue?vue&type=template&id=2c833d09&"
import script from "./UnassignedList.vue?vue&type=script&lang=js&"
export * from "./UnassignedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports